/* eslint-disable complexity */
// avoiding package root import to avoid circular dependency
// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
// eslint-disable-next-line monorepo/no-internal-import
import {assertUnreachable} from '@aboutyou/utils/src/assertUnreachable';
import {LEGAL_PAGE_TYPE, StaticLegalPageRoutes} from './legalPagesRouteKeys';

export function getStaticPagesByLocale_UNSAFE(
  locale: Locale,
): StaticLegalPageRoutes {
  switch (locale) {
    case Locale.de_AT:
    case Locale.de_CH:
    case Locale.de_DE:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'datenschutz',
        [LEGAL_PAGE_TYPE.FAQ]: 'haeufige-fragen',
        [LEGAL_PAGE_TYPE.Imprint]: 'impressum',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'agb',
        [LEGAL_PAGE_TYPE.TermsOfUse]: 'nutzungsbedingungen',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'teilnahmebedingungen-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'teilnahmebedingungen-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'teilnahmebedingungen-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'teilnahmebedingungen-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'teilnahmebedingungen-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'teilnahmebedingungen-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'nutzungsbedingungen-und-guidelines-fuer-kundenbewertungen',
        [LEGAL_PAGE_TYPE.GeneralConditionsReverseSupply]: 'agb-reverse-supply',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-liste',
      };
    case Locale.cs_CZ:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'ochrana-dat',
        [LEGAL_PAGE_TYPE.FAQ]: 'caste-dotazy',
        [LEGAL_PAGE_TYPE.Imprint]: 'impresum',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'vseobecne-obchodni-podminky',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'podminky-akce-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'podminky-akce-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'podminky-akce-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'podminky-akce-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'podminky-ucasti-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'podminky-akce-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'podminky-pouziti-a-pokyny-pro-hodnoceni-zakazniku',
        [LEGAL_PAGE_TYPE.Cookies]: 'seznam-souboru-cookies',
      };
    case Locale.fr_BE:
    case Locale.fr_CH:
    case Locale.fr_FR:
    case Locale.fr_LU:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'protection-des-donnees',
        [LEGAL_PAGE_TYPE.FAQ]: 'questions-frequemment-posees',
        [LEGAL_PAGE_TYPE.Imprint]: 'mentions-legales',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'cgv',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]:
          'conditions-de-participation-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]:
          'conditions-de-participation-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]:
          'conditions-de-participation-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]:
          'conditions-de-participation-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]:
          'conditions-de-participation-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'conditions-de-participation-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'conditions-d-utilisation-et-directives-pour-les-evaluations-des-clients',
        [LEGAL_PAGE_TYPE.Cookies]: 'liste-des-cookies',
      };
    case Locale.nl_BE:
    case Locale.nl_NL:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privacy-verklaring',
        [LEGAL_PAGE_TYPE.FAQ]: 'veelgestelde-vragen',
        [LEGAL_PAGE_TYPE.Imprint]: 'colofon',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'algemene-voorwaarden',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]:
          'voorwaarden-voor-deelname-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]:
          'voorwaarden-voor-deelname-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'voorwaarden-voor-deelname-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'voorwaarden-voor-deelname-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]:
          'voorwaarden-voor-deelname-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'voorwaarden-voor-deelname-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'gebruiksvoorwaarden-en-richtlijnen-voor-klantbeoordelingen',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-lijst',
      };
    case Locale.pl_PL:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'polityka-prywatnosci',
        [LEGAL_PAGE_TYPE.FAQ]: 'najczesciej-zadawane-pytania',
        [LEGAL_PAGE_TYPE.Imprint]: 'imprint',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'warunki-ogolne',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'regulamin-promocji-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'regulamin-promocji-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'regulamin-promocji-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'regulamin-promocji-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'warunki-uczestnictwa-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'regulamin-promocji-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'warunki-korzystania-i-wytyczne-dla-wystawiania-opinii-przez-klientow',
        [LEGAL_PAGE_TYPE.Cookies]: 'lista-plikow-cookie',
      };
    case Locale.ro_RO:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'politica-de-confidentialitate',
        [LEGAL_PAGE_TYPE.FAQ]: 'intrebari-frecvente',
        [LEGAL_PAGE_TYPE.Imprint]: 'date-juridice',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'termeni-si-conditii',
        [LEGAL_PAGE_TYPE.TermsOfUse]: 'conditii-de-utilizare',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'reguli-participare-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'reguli-participare-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'reguli-participare-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'reguli-participare-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'conditii-participare-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'reguli-participare-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'conditii-de-utilizare-si-orientari-pentru-evaluarile-clientilor',
        [LEGAL_PAGE_TYPE.Cookies]: 'lista-cookie-uri',
      };
    case Locale.hu_HU:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'adatvedelem',
        [LEGAL_PAGE_TYPE.FAQ]: 'gyik',
        [LEGAL_PAGE_TYPE.Imprint]: 'impresszum',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'aszf',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'reszveteli-feltetelek-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'reszveteli-feltetelek-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'reszveteli-feltetelek-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'reszveteli-feltetelek-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'reszveteli-feltetelek-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'reszveteli-feltetelek-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'felhasznaloi-feltetelek-es-iranyelvek-az-uegyfelertekelesekhez',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-lista',
      };
    case Locale.sk_SK:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'ochrana-dat',
        [LEGAL_PAGE_TYPE.FAQ]: 'caste-otazky',
        [LEGAL_PAGE_TYPE.Imprint]: 'impresum',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'vseobecne-obchodne-podmienky',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'podmienky-ucasti-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'podmienky-ucasti-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'podmienky-ucasti-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'podmienky-ucasti-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'podmienky-ucasti-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'podmienky-ucasti-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'podmienky-pouzivania-a-smernice-pre-zakaznicke-hodnotenia',
        [LEGAL_PAGE_TYPE.Cookies]: 'zoznam-suborov-cookies',
      };
    case Locale.sl_SI:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'varstvo-podatkov',
        [LEGAL_PAGE_TYPE.FAQ]: 'pogosta-vprasanja',
        [LEGAL_PAGE_TYPE.Imprint]: 'osnovni-podatki',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'splosni-pogoji-poslovanja',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]:
          'splosni-pogoji-sodelovanja-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]:
          'splosni-pogoji-sodelovanja-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'splosni-pogoji-sodelovanja-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'splosni-pogoji-sodelovanja-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]:
          'splosni-pogoji-sodelovanja-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'splosni-pogoji-sodelovanja-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'pogoji-uporabe-in-smernice-za-ocene-strank',
        [LEGAL_PAGE_TYPE.Cookies]: 'seznam-piskotkov',
      };
    case Locale.lv_LV:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privatuma-politika',
        [LEGAL_PAGE_TYPE.FAQ]: 'buj',
        [LEGAL_PAGE_TYPE.Imprint]: 'nospiedums',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'visparigie-nosacijumi',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'dalibas-nosacijumi-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'dalibas-nosacijumi-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'dalibas-nosacijumi-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'dalibas-nosacijumi-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'dalibas-nosacijumi-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'dalibas-nosacijumi-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'lietosanas-noteikumi-un-vadlinijas-klientu-atsauksmem',
        [LEGAL_PAGE_TYPE.Cookies]: 'sikdatnu-saraksts',
      };
    case Locale.lt_LT:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privatumo-politika',
        [LEGAL_PAGE_TYPE.FAQ]: 'duk',
        [LEGAL_PAGE_TYPE.Imprint]: 'rekvizitai',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'naudojimosi-salygos',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'dalyvavimo-salygos-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'dalyvavimo-salygos-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'dalyvavimo-salygos-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'dalyvavimo-salygos-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'dalyvavimo-salygos-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'dalyvavimo-salygos-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'naudojimo-salygos-ir-klientu-atsiliepimu-gaires',
        [LEGAL_PAGE_TYPE.Cookies]: 'slapuku-sarasas',
      };
    case Locale.et_EE:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privaatsuspoliitika',
        [LEGAL_PAGE_TYPE.FAQ]: 'kkk',
        [LEGAL_PAGE_TYPE.Imprint]: 'impressum',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'uldtingimused',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'osalemistingimused-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'osalemistingimused-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'osalemistingimused-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'osalemistingimused-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'osalemistingimused-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'osalemistingimused-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'kasutustingimused-ja-juhised-klientide-arvustustele',
        [LEGAL_PAGE_TYPE.Cookies]: 'kupsiste-nimekiri',
      };
    case Locale.hr_HR:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'zastita-podataka',
        [LEGAL_PAGE_TYPE.FAQ]: 'najcesca-pitanja',
        [LEGAL_PAGE_TYPE.Imprint]: 'osnovne-informacije',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'opci-uvjeti-poslovanja',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'uvjeti-sudjelovanja-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'uvjeti-sudjelovanja-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'uvjeti-sudjelovanja-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'uvjeti-sudjelovanja-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'uvjeti-sudjelovanja-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'uvjeti-sudjelovanja-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'uvjeti-koristenja-i-smjernice-za-ocjene-kupaca',
        [LEGAL_PAGE_TYPE.Cookies]: 'popis-kolacica',
      };
    case Locale.bg_BG:
    case Locale.da_DK:
    case Locale.en_IE:
    case Locale.sv_SE:
    case Locale.fi_FI:
    case Locale.en_DE:
    case Locale.en_ZZ:
    case Locale.ar_SA:
    case Locale.en_SA:
    case Locale.he_IL:
    case Locale.en_IL:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privacy-policy',
        [LEGAL_PAGE_TYPE.FAQ]: 'faq',
        [LEGAL_PAGE_TYPE.Imprint]: 'imprint',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'general-conditions',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'terms-of-participation_fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'terms-of-participation_fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'terms-of-participation_ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'terms-of-participation_dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'terms-of-participation-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'terms-of-participation-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'terms-of-use-and-guidelines-for-customer-reviews',
        [LEGAL_PAGE_TYPE.GeneralConditionsReverseSupply]:
          'general-conditions-reverse-supply',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.es_ES:
    case Locale.es_ZZ:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'politica-de-privacidad',
        [LEGAL_PAGE_TYPE.FAQ]: 'preguntas-frecuentes',
        [LEGAL_PAGE_TYPE.Imprint]: 'aviso-legal',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'terminos-y-condiciones',
        [LEGAL_PAGE_TYPE.TermsOfUse]: 'condiciones-de-uso',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]:
          'condiciones-de-participacion-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]:
          'condiciones-de-participacion-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]:
          'condiciones-de-participacion-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]:
          'condiciones-de-participacion-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]:
          'requisitos-de-participacion-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'condiciones-de-participacion-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'condiciones-de-uso-y-pautas-para-las-resenas-de-los-clientes',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
        [LEGAL_PAGE_TYPE.TermsOfUseBestPriceGuarantee]: 'best-price-guarantee',
      };
    case Locale.it_IT:
    case Locale.it_CH:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'informativa-sulla-privacy',
        [LEGAL_PAGE_TYPE.FAQ]: 'domande-frequenti',
        [LEGAL_PAGE_TYPE.Imprint]: 'informazioni-legali',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'condizioni-generali-di-vendita',
        [LEGAL_PAGE_TYPE.TermsOfUse]: 'condizioni-di-utilizzo',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]:
          'condizioni-di-partecipazione-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]:
          'condizioni-di-partecipazione-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]:
          'condizioni-di-partecipazione-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]:
          'condizioni-di-partecipazione-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]:
          'condizioni-per-la-partecipazione-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'condizioni-di-partecipazione-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'condizioni-di-utilizzo-e-linee-guida-per-recensioni-dei-clienti',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.pt_PT:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'politica-de-privacidade',
        [LEGAL_PAGE_TYPE.FAQ]: 'perguntas-frequentes',
        [LEGAL_PAGE_TYPE.Imprint]: 'aviso-legal',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'termos-e-condicoes',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'termos-de-participacao-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'termos-de-participacao-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'termos-de-participacao-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'termos-de-participacao-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'termos-de-participacao-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'termos-de-participacao-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'termos-de-uso-e-diretrizes-para-avaliacoes-de-clientes',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.el_GR:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privacy-policy',
        [LEGAL_PAGE_TYPE.FAQ]: 'faq',
        [LEGAL_PAGE_TYPE.Imprint]: 'imprint',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'terms-and-conditions',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'terms-of-participation_fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'terms-of-participation_fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'terms-of-participation_ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'terms-of-participation_dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'terms-of-participation-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'terms-of-participation-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'ori-khrisis-kai-katefthintiries-grammes-yia-axioloyisis-pelaton',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.no_NO:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'personvernretningslinjer',
        [LEGAL_PAGE_TYPE.FAQ]: 'faq',
        [LEGAL_PAGE_TYPE.Imprint]: 'kolofon',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'vilkar-og-betingelser',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'deltakelsesvilkar-fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'deltakelsesvilkar-fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'deltakelsesvilkar-ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'deltakelsesvilkar-dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'deltakelsesvilkar-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]: 'deltakelsesvilkar-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'vilkar-for-bruk-og-retningslinjer-for-kundeanmeldelser',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.el_CY:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'privacy-policy',
        [LEGAL_PAGE_TYPE.FAQ]: 'faq',
        [LEGAL_PAGE_TYPE.Imprint]: 'imprint',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'terms-and-conditions',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'terms-of-participation_fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'terms-of-participation_fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'terms-of-participation_ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'terms-of-participation_dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'terms-of-participation-nps',
        [LEGAL_PAGE_TYPE.TermsAndConditionsTiktok]:
          'terms-of-participation-tiktok',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'ori-khrisis-kai-katefthintiries-grammes-yia-axioloyisis-pelaton',
        [LEGAL_PAGE_TYPE.Cookies]: 'cookie-list',
      };
    case Locale.ru_EE:
    case Locale.ru_LV:
      return {
        [LEGAL_PAGE_TYPE.Privacy]: 'politika-konfidentsialnosti',
        [LEGAL_PAGE_TYPE.FAQ]: 'h',
        [LEGAL_PAGE_TYPE.Imprint]: 'svedeniya',
        [LEGAL_PAGE_TYPE.TermsAndConditions]: 'polozheniya-i-usloviya',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB1]: 'terms-of-participation_fb-1',
        [LEGAL_PAGE_TYPE.TermsAndConditionsFB2]: 'terms-of-participation_fb-2',
        [LEGAL_PAGE_TYPE.TermsAndConditionsIG]: 'terms-of-participation_ig',
        [LEGAL_PAGE_TYPE.TermsAndConditionsDP]: 'terms-of-participation_dp',
        [LEGAL_PAGE_TYPE.TermsAndConditionsNPS]: 'usloviya-uchastiya-nps',
        [LEGAL_PAGE_TYPE.TermsOfUseReviews]:
          'usloviya-ispolzovaniya-otzyvov-klientov',
        [LEGAL_PAGE_TYPE.Cookies]: 'spisok-failov-cookie',
      };
    default:
      assertUnreachable(locale);
  }
}

export enum LEGAL_PAGE_COMPONENT {
  AboutUs = 'aboutUs',
  CampaignConditions = 'campaignConditions',
  Contact = 'contact',
  DeliveryCosts = 'deliveryCosts',
  Payment = 'payment',
}

export function getPageComponentKeysByLocale_UNSAFE(
  locale: Locale,
): Record<LEGAL_PAGE_COMPONENT, string> {
  switch (locale) {
    case Locale.de_AT:
    case Locale.de_CH:
    case Locale.de_DE:
      return {
        aboutUs: 'ueber-uns',
        campaignConditions: 'aktionsbedingungen',
        contact: 'kontakt',
        deliveryCosts: 'versand-und-lieferkosten',
        payment: 'zahlung',
      };

    case Locale.cs_CZ:
      return {
        aboutUs: 'o-nas',
        campaignConditions: 'podminky-akce',
        contact: 'kontakt',
        deliveryCosts: 'doprava-a-postovne',
        payment: 'platba',
      };

    case Locale.fr_BE:
    case Locale.fr_CH:
      return {
        aboutUs: 'a-propos-de-nous',
        campaignConditions: 'conditions-des-promotions',
        contact: 'contact',
        deliveryCosts: 'expedition-et-frais-de-port',
        payment: 'paiement',
      };

    case Locale.nl_BE:
    case Locale.nl_NL:
      return {
        aboutUs: 'about-us',
        campaignConditions: 'actievoorwaarden',
        contact: 'contact',
        deliveryCosts: 'verzend-en-leverkosten',
        payment: 'betaling',
      };

    case Locale.pl_PL:
      return {
        aboutUs: 'o-nas',
        campaignConditions: 'regulamin-promocji',
        contact: 'kontakt',
        deliveryCosts: 'koszty-wysylki-i-dostawy',
        payment: 'platnosc',
      };

    case Locale.hu_HU:
      return {
        aboutUs: 'rolunk',
        campaignConditions: 'akcio-feltetelei',
        contact: 'kapcsolat',
        deliveryCosts: 'szallitasi-koltsegek',
        payment: 'fizetes',
      };
    case Locale.ro_RO:
      return {
        aboutUs: 'despre-noi',
        campaignConditions: 'conditii-promotie',
        contact: 'contact',
        deliveryCosts: 'transport-si-costuri-livrare',
        payment: 'plata',
      };
    case Locale.sk_SK:
      return {
        aboutUs: 'o-nas',
        campaignConditions: 'podmienky-akcie',
        contact: 'kontakt',
        deliveryCosts: 'dorucenie-a-postovne',
        payment: 'platba',
      };
    case Locale.sl_SI:
      return {
        aboutUs: 'o-nas',
        campaignConditions: 'akcijski-pogoji',
        contact: 'kontakt',
        deliveryCosts: 'stroski-dostave',
        payment: 'placilo',
      };
    case Locale.lv_LV:
      return {
        aboutUs: 'par-zimolu',
        campaignConditions: 'kampanas-nosacijumi',
        contact: 'kontakti',
        deliveryCosts: 'piegade',
        payment: 'maksajums',
      };
    case Locale.lt_LT:
      return {
        aboutUs: 'apie-mus',
        campaignConditions: 'akcijos-salygos',
        contact: 'kontaktai',
        deliveryCosts: 'pristatymas',
        payment: 'atsiskaitymas',
      };
    case Locale.et_EE:
      return {
        aboutUs: 'meist',
        campaignConditions: 'kampaania-tingimused',
        contact: 'kontakt',
        deliveryCosts: 'tarnekulu',
        payment: 'tasumine',
      };
    case Locale.hr_HR:
      return {
        aboutUs: 'o-nama',
        campaignConditions: 'uvjeti-posebne-ponude',
        contact: 'kontakt',
        deliveryCosts: 'troskovi-dostave',
        payment: 'placanje',
      };
    case Locale.bg_BG:
      return {
        aboutUs: 'about-us',
        campaignConditions: 'promotion-conditions',
        contact: 'contact',
        deliveryCosts: 'delivery-costs',
        payment: 'payment',
      };
    case Locale.fr_LU:
      return {
        aboutUs: 'a-propos-de-nous',
        campaignConditions: 'conditions-des-promotions',
        contact: 'contact',
        deliveryCosts: 'expedition-et-frais-de-port',
        payment: 'paiement',
      };
    case Locale.en_ZZ:
    case Locale.da_DK:
    case Locale.en_IE:
    case Locale.en_DE:
    case Locale.fr_FR:
    case Locale.sv_SE:
    case Locale.fi_FI:
    case Locale.ar_SA:
    case Locale.en_SA:
    case Locale.he_IL:
    case Locale.en_IL:
      return {
        aboutUs: 'about-us',
        campaignConditions: 'campaign-conditions',
        contact: 'contact',
        deliveryCosts: 'delivery-costs',
        payment: 'payment',
      };
    case Locale.es_ZZ:
    case Locale.es_ES:
      return {
        aboutUs: 'sobre-nosotros',
        campaignConditions: 'condiciones-de-campanas',
        contact: 'contacto',
        deliveryCosts: 'gastos-de-envio-y-entrega',
        payment: 'pago',
      };
    case Locale.it_IT:
    case Locale.it_CH:
      return {
        aboutUs: 'chi-siamo',
        campaignConditions: 'condizioni-della-promozione',
        contact: 'contatti',
        deliveryCosts: 'costi-di-spedizione',
        payment: 'pagamento',
      };
    case Locale.pt_PT:
      return {
        aboutUs: 'sobre-nos',
        campaignConditions: 'condicoes-da-promocao',
        contact: 'perguntas-frequentes/contacto',
        deliveryCosts: 'perguntas-frequentes/taxas-de-envio-e-entrega',
        payment: 'perguntas-frequentes/pagamento',
      };
    case Locale.el_CY:
    case Locale.el_GR:
      return {
        aboutUs: 'about-us',
        campaignConditions: 'campaign-terms-and-conditions',
        contact: 'faq/contact',
        deliveryCosts: 'faq/shipping-and-delivery-costs',
        payment: 'faq/payment',
      };
    case Locale.no_NO:
      return {
        aboutUs: 'om-oss',
        campaignConditions: 'kampanje-vilkar-og-betingelser',
        contact: 'faq/kontakt',
        deliveryCosts: 'faq/frakt-og-leveringskostnader',
        payment: 'faq/betaling',
      };
    case Locale.ru_EE:
    case Locale.ru_LV:
      return {
        aboutUs: 'about-us', // about us url will always redirect to 'https://corporate.aboutyou.de/en/', see redirect.paths.tsx file
        campaignConditions: 'usloviya-aktsii',
        contact: 'kontakty',
        deliveryCosts: 'stoimost-dostavki',
        payment: 'oplata',
      };
    default:
      assertUnreachable(locale);
  }
}
